import { useNavigate, useParams } from "react-router-dom";

export enum AdminTabs {
    Users = 'users',
    Appearance = 'appearance',
}

export function useAdminTabs() {
    const navigate = useNavigate();
    const { tab } = useParams<{ tab: AdminTabs }>();

    const setTab = (value: AdminTabs) => {
        navigate(`/admin/${value}`);
    };

    return {
        currentTab: tab,
        setTab,
    };
}